<template>
  <div class="table-wrapper">
    <el-table
      :data="data"
      stripe
      style="width: 100%"
      size="medium"
      header-row-class-name="common-table-header"
      row-class-name="common-table-row"
      class="is-print-hide common-table"
      :border="false"
    >
      <el-table-column prop="name" label="大区名称" width="180"></el-table-column>
      <el-table-column prop="storeNameList" label="大区管辖门店">
        <template #default="{ row: { storeNameList } }">
          <div class="stores">
            <span class="names">
              {{ storeNameList | showStoreName }}
            </span>
            <span class="count">共{{ storeNameList.length }}家</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
      <el-table-column width="100">
        <template #header>
          <span class="operate-header">操作</span>
        </template>
        <template #default="{ row: { id } }">
          <div class="operate-bar">
            <span class="operate" @click="$router.push(`/shopManagement/area/${id}`)">编辑</span>
            <span class="operate" @click="$router.push(`/shopManagement/areaDetail/${id}`)">查看</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-wrapper">
      <el-pagination
        class="is-print-hide common-el-pagination"
        layout="prev, pager, next, total, jumper, sizes"
        :total="total"
        :current-page="pageNo"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        @current-change="val => $emit('handle-pageNo', val)"
        @size-change="val => $emit('handle-pageSize', val)"
      />
      <div class="sureJump global_common_button_goast">确定</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AreaTable',
  props: ['data', 'total', 'pageNo', 'pageSizes', 'pageSize'],
  filters: {
    showStoreName(val) {
      if (val && val.length > 0) {
        if (val.length < 10) {
          return val.join('、');
        }
        return val.filter((o, i) => i < 5).join('、');
      }
      return '';
    }
  }
};
</script>

<style lang="scss" scoped>
.table-wrapper {
  .pagination-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 22px;

    /deep/.el-pagination {
      margin-top: 0;
    }

    .sureJump {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
      width: 80px;
      height: 32px;
      border-radius: 3px;
      cursor: pointer;
    }
  }

  .stores {
    display: flex;

    .names {
      margin-right: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 95%;
    }

    .count {
      flex: 1;
    }
  }

  .operate-header {
    display: inline-block;
    width: 100%;
    text-align: center;
  }

  .operate-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;

    .operate {
      color: #1e8dff;
      cursor: pointer;
    }
  }
}
</style>
